<template>
  <router-view />
  <notifications position="bottom center" />
</template>

<script>
import { onMounted } from '@vue/runtime-core';
import { useStore } from 'vuex';
export default {
  setup() {
    const store = useStore();
    onMounted(() => {
      store.commit('setConnectionAdminList', [
        { value: 'ctm', text: 'CTM - Solutions' },
        { value: 'itm', text: 'ITM - Global' },
      ]);

      store.commit('setRoadMapTypeList', [
        { value: 'N', text: '사용하지 않음' },
        { value: 'ctm', text: '전화영어로드맵' },
        { value: 'image', text: '이미지' },
      ]);

      /**
       * @description : store 데이터 저장
       * 1. hq 매니저 저장
       * 2. team 리스트 저장
       * 3. 템플렛 리스트 저장
       * 4. 카테고리 리스트 저장
       */
      if (store.getters.getTokenInfo) {
        store.dispatch('apiHqManagerList');
        store.dispatch('apiTemaList');
        store.dispatch('apiTemplateList');
        store.dispatch('apiFaqCategoryList');
      }
    });
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap');
html,
body,
#app {
  margin: 0;
  height: 100%;
  font-family: 'Noto Sans KR', sans-serif;
  word-break: keep-all;
}
</style>
